import UITable from 'UIComponents/table/UITable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CategoryMappingTableRow from './ForecastCategoryMappingTableRow';
import { DEFAULT_CATEGORIES_NOT_MAPPABLE } from '../../../constants/ForecastCategories';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ForecastCategoryMappingTable = ({
  forecastCategories,
  dealStageMapping,
  pipelineId
}) => {
  const automated = dealStageMapping.automate;
  return /*#__PURE__*/_jsxs(UITable, {
    condensed: true,
    hover: false,
    style: {
      opacity: automated ? 1 : 0.5
    },
    className: "m-bottom-4",
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {
        style: {
          width: '30%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '70%'
        }
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "wizard.map.table.forecastCategory"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "wizard.map.table.dealStages"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: forecastCategories.map(forecastCategory => {
        const dealStageReadOnly = !automated || DEFAULT_CATEGORIES_NOT_MAPPABLE.includes(forecastCategory.value);
        return /*#__PURE__*/_jsx(CategoryMappingTableRow, {
          forecastCategory: forecastCategory,
          dealStageMapping: dealStageMapping,
          dealStageReadOnly: dealStageReadOnly,
          pipelineId: pipelineId
        }, forecastCategory.value);
      })
    })]
  });
};
export default ForecastCategoryMappingTable;